export default __webpack_public_path__ + "static/media/yael-shimeoni.1afde1c7.png";